// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__qpyK2","spinner":"Spinner_spinner__1Neu5"};